<template>
  <component :is="$attrs.onClick ? LButton : 'div'" class="flex gap-2 items-center whitespace-nowrap">
    <svg class="flex fill-slate-200 dark:fill-gray-700 items-center size-4" viewBox="0 0 216 192">
      <rect x="0" y="144" rx="11" :class="['w-6 h-12', chances >= Chance.LOW && color]"/>
      <rect x="48" y="108" rx="11" :class="['w-6 h-[5.25rem]', chances >= Chance.LOW_MEDIUM && color]"/>
      <rect x="96" y="72" rx="11" :class="['w-6 h-[7.5rem]', chances >= Chance.MEDIUM && color]"/>
      <rect x="144" y="36" rx="11" :class="['w-6 h-[9.75rem]', chances >= Chance.MEDIUM_HIGH && color]"/>
      <rect x="192" y="0" rx="11" :class="['w-6 h-48', chances >= Chance.HIGH && color]"/>
    </svg>
    {{ label }}
  </component>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"
import { Chance } from "@/models/Chance"
import { computed } from "vue"

const props = defineProps({
  label: String,
  partTime: Boolean,
  school: Object,
  value: Number,
})

const colors = {
  [Chance.LOW]: "fill-red-500",
  [Chance.LOW_MEDIUM]: "fill-orange-400",
  [Chance.MEDIUM]: "fill-yellow-500",
  [Chance.MEDIUM_HIGH]: "fill-green-400",
  [Chance.HIGH]: "fill-green-600",
}

const labels = {
  [Chance.LOW]: "Low chances",
  [Chance.LOW_MEDIUM]: "Low-Medium chances",
  [Chance.MEDIUM]: "Medium chances",
  [Chance.MEDIUM_HIGH]: "Medium-High chances",
  [Chance.HIGH]: "High chances",
  [Chance.INSUFFICIENT_DATA]: "Admission chances",
}

const chances = computed(() => parseInt(props.value ?? props.school?.[field.value] ?? Chance.INSUFFICIENT_DATA))

const color = computed(() => colors[chances.value])

const field = computed(() => `admission_chances${props.partTime ? "_pt" : ""}`)

const label = computed(() => props.label ?? labels[chances.value])
</script>
